import { AlertClassColour, ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { BulkOrderDTO } from 'src/app/core/models/system/order/order-bulk.dto';
import { catchError, forkJoin, Observable, throwError } from 'rxjs';
import { CompanyModalFormComponent } from '../../_company/company-modal-form/company-modal-form.component';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DeviceActivationType, DeviceOSType, eDeviceType, LimitType } from 'src/app/core/enums';
import { DropdownCountryDiallingCodeComponent } from 'src/app/core/dropdowns/country-dialling-code/dropdown-country-dialling-code.component';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators, ValidatorFn } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InviewUserDTO } from 'src/app/core/models/inview/inview-user.dto';
import { InviewCostCentresService } from 'src/app/core/services/utelize/inview/inview-cost-centres-service';
import { InviewUsersClisService } from 'src/app/core/services/utelize/inview/inview-users-clis-service';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { ProductsService } from 'src/app/core/services/utelize/system/product/products-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { UserModalFormComponent } from '../../_user/user-modal-form/user-modal-form.component';
import { PhoneNumberService } from 'src/app/core/services/utelize/general/phone-number-service';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { ValidatorService } from 'src/app/core/services/utelize/general/validator-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-provision-bulk-order-modal-form',
  templateUrl: './provision-bulk-order-modal-form.component.html',
  styleUrls: ['./provision-bulk-order-modal-form.component.scss'],
  //encapsulation: ViewEncapsulation.None
})

export class BulkOrderModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() embeddedFormMode      : boolean | undefined;
  @Input() initialCompanyId      : number  | undefined;
  @Input() initialInviewCompanyId: number  | undefined;

  @Output() bulkOrderFormCancelled   : EventEmitter<void> = new EventEmitter<void>();
  @Output() bulkOrderDataHasBeenSaved: EventEmitter<any>  = new EventEmitter<any>();

  @ViewChild('companyModalForm',          { static: false }) companyModalForm!         : CompanyModalFormComponent;
  @ViewChild('completedModalForm',        { static: false }) completedModalForm!       : CompletedModalFormComponent;
  @ViewChild('bulkOrderModalFormContent', { static: false }) bulkOrderModalFormContent!: TemplateRef<void>;
  @ViewChild('userModalForm',             { static: false }) userModalForm!            : UserModalFormComponent;
  @ViewChild('dialCodeDropdown'                            ) dialCodeDropdown!         : DropdownCountryDiallingCodeComponent;
  @ViewChild('warningModalForm',          { static: false }) warningModalForm!         : WarningModalFormComponent;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static"     : (value.toUpperCase()=="TRUE" ? true : false) }
  get showCostCentres() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ProvisioningBulkShowCostCentres, true); }
  
  // private completedOrderStatus     : string="Provisioned";
  private bulkOrder                   : BulkOrderDTO | undefined;
  private bulkOrderSavedMessage       : string="Changes applied.";
  private curUser                     : SystemUserDTO;
  private initialEmail                : string="";
  private initialInviewCompanyIdSet   : boolean=false;
  private initialMobile               : string="";
  private initialStatus               : string="Please complete the following details";
  private initialUserExists           : boolean=false;
  // private initialOrderStatus          : string="Pending";
  private inviewCompanyIdData!        : IdAndDescriptionDTO[];
  private inviewCostCentreIdLv1Data!  : IdAndDescriptionDTO[];
  private inviewCostCentreIdLv2Data!  : IdAndDescriptionDTO[];
  private inviewCostCentreIdLv1Auto   : number=0;
  private inviewCostCentreIdLv2Auto   : number=0;
  private inviewUserIdData!           : InviewUserDTO[];
     
  //RBW_20260805 - The mobilenumber reactive control is disabled on this form (the dial-code dropdown owns the real input), so Angular
  //               skips its validators and it never carries an error. Drive the conflict display from this flag instead.
  public mobileConflict       : boolean = false;
  public mobileConflictMessage: string  = "";
  //private statusObservable            : Observable<number> | undefined;
  private productIdData!              : IdAndDescriptionDTO[];
  private bulkOrderModalFormRef!      : NgbModalRef;
  //private statusCheck                 : ReplaySubject<boolean> = new ReplaySubject(1);
  private sureSimUserId               : number | undefined;
  //private selectedInviewCompany?      : IdAndDescriptionDTO;
  private selectedProductid           : number | undefined;
  private selectedInviewCostCentreLv1id: number | undefined;
  private selectedInviewCostCentreLv2id: number | undefined;

  public addCompanyButtonEnabled      : boolean=true;
  public addUserButtonEnabled         : boolean=false;
  public alertColourOrderStatus       : string=AlertClassColour.Grey;
  public alertColourProgress          : string=AlertClassColour.Grey;
  public breadCrumbItems!             : Array<{}>;
  public bulkOrderForm!               : UntypedFormGroup;
  // public costCentreAddFormSubmitted   : boolean=false;
  // public costCentreAddForm!           : UntypedFormGroup;
  public costCentreLv1ButtonEnabled   : boolean=false;
  public costCentreLevel              : number=0;
  public costCentreMissingInInview    : boolean=false;
  public formSubmitted                : boolean=false;
  public formTitle                    : string="Bulk Provisioning Details";
  public inviewCompanyId              : number | undefined;
  public provisionButtonEnabled       : boolean=false;
  //public provisioningInProgress       : boolean=false;
  public progressInformation          : string=this.initialStatus;
  public submitButtonEnabled          : boolean=true;
  public sureSimCompanyId             : number | undefined;
  public useInternationalDialCode     : boolean=false;
  public warningMessageMain           : string | undefined;
  public warningMessageSub            : string | undefined;

  //RBW_20260604 - Dropdown options for the new provisioning columns (ids match the backend PublicEnums)
  public deviceOSOptions     : IdAndDescriptionDTO[] = [{ id: DeviceOSType.AppleIOS,description: "Apple iOS"}, 
                                                        { id: DeviceOSType.Android, description: "Android"  }, 
                                                        { id: DeviceOSType.Windows, description: "Windows"  }];
  public provisionTypeOptions: IdAndDescriptionDTO[] = [{ id: DeviceActivationType.PushViaEID,    description: "EID"    },
                                                        { id: DeviceActivationType.PushViaICCID,  description: "ICCID"  },
                                                        { id: DeviceActivationType.SendViaSMS,    description: "SMS"    },
                                                        { id: DeviceActivationType.SendViaEmail,  description: "Email"  },
                                                        { id: DeviceActivationType.SendViaManual, description: "Manual" }];
  public simTypeOptions      : IdAndDescriptionDTO[] = [{ id: eDeviceType.esim,description: "eSIM"},
                                                        { id: eDeviceType.sim, description: "SIM" }];
  public yesNoOptions        : IdAndDescriptionDTO[] = [{ id: false,description: "No"  },
                                                        { id: true, description: "Yes" }];
  public useTypeOptions      : IdAndDescriptionDTO[] = [{ id: false,description: "Physical User" },
                                                        { id: true, description: "IOT Device"    }];
  public limitTypeOptions    : IdAndDescriptionDTO[] = [{ id: LimitType.Off,   description: "No Limit" },
                                                        { id: LimitType.Spend, description: "Spend"    },
                                                        { id: LimitType.Data,  description: "Data"     }];
  public dataWeightOptions   : IdAndDescriptionDTO[] = [{ id: "MB", description: "MB" },
                                                        { id: "GB", description: "GB" }];

  //#region for Validators
  
  public eidLength                    : number=32;
  public emailMaxLength               : number=100;
  public firstnameMaxLength           : number=100;
  public lastnameMaxLength            : number=100;
  public mobilenumberMaxLength        : number=100;
  public tagMaxLength                 : number=50;
  public tag2MaxLength                : number=50;
  public usernameMaxLength            : number=100;
  
  //#endregion 

  constructor(
    private authenticationService   : AuthenticationService,
    private configSystemService     : ConfigSystemService,
    private exceptionsService       : ExceptionsService,
    private formBuilder             : UntypedFormBuilder,
    private inviewUsersClisService  : InviewUsersClisService,
    private inviewCostCentresService: InviewCostCentresService,
    private lastPassKillerService   : LastPassKillerService,
    private modalService            : NgbModal,
    private ordersService           : OrdersService,
    private phoneNumberService      : PhoneNumberService,
    private productsService         : ProductsService,
    private usersService            : UsersService,
    private validatorService        : ValidatorService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      this.sureSimCompanyId        =this.initialCompanyId;
      this.inviewCompanyId         =this.initialInviewCompanyId;
      this.useInternationalDialCode=this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserUseInternationalDialCode, false);

      // if (this.embeddedFormMode) {
        this.startProcess();
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    try {
      //this.simProvisionBulkEmbeddedComponent.closeForm();
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      // this.addCompanyButtonEnabled  =true;
      // this.addUserButtonEnabled     =false;
      this.alertColourProgress      =AlertClassColour.Grey;
      this.formSubmitted            =false;
      this.mobileConflict           =false;
      // this.initialInviewCompanyIdSet=false;
      // this.progressInformation      =this.initialStatus;
      // this.provisionButtonEnabled   =false;
      // this.registerInviewCompany    =false;
      // this.registerInviewUser       =false;
      // this.selectedInviewCompany  =undefined;
      // this.selectedInviewUserId     =undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public closeForm(): void {
    try {
      //this.simProvisionBulkEmbeddedComponent.closeForm()
      this.bulkOrderModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  // public openForm(companyId:number, inviewCompanyId:number): void {
  //   try {
  //     this.sureSimCompanyId = companyId;
  //     this.inviewCompanyId  = inviewCompanyId;
  //     this.startProcess();
  //     this.openModal();
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }

    public openForm(bulkOrderGuid: string, bulkOrderId: number, mobileConflictMessage:string, userExists:boolean): void {
    try {
      // this.associateUser            =(userType==eUser.associate);
      // this.initialInviewCompanyIdSet=false;
      // this.portalUser               =(userType==eUser.portal);
      // this.userType                 =userType;

      this.initialUserExists = userExists;
      this.resetMainVariables();
      this.refreshInviewCompanyData();
      this.setUpForm();
      
      // if (sureSimUserId != undefined && <number>sureSimUserId>0) {
      //   this.formTitle    =(this.userType==eUser.portal ? "Manage Portal User" : (this.userType==eUser.sim ? "Manage User" : "Manage Associate"));
      //   this.newUser      =false;
      //   this.sureSimUserId=sureSimUserId;

      //   this.componentAccessUserService.hasAccessGuid(AccessGuids.FormUserChangeUserRole) ? this.userForm.controls["accessTypeId"].enable() : this.userForm.controls["accessTypeId"].disable();
      
      //   this.getSureSimUser();
      // } else {
      //   this.formTitle    =(this.userType==eUser.portal ? "Create Portal User" : (this.userType==eUser.sim ? "Create User" : "Create Associate"));
      //   this.newUser      =true;
      //   this.sureSimUserId=0;
        
      //   this.enableDisableControls(false);
      this.getBulkOrderAndOpenModal(bulkOrderGuid, bulkOrderId, mobileConflictMessage);
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private getBulkOrderAndOpenModal(bulkOrderGuid:string, bulkOrderId: number, mobileConflictMessage:string): void {
    try {
      this.ordersService.getBulkOrderById(bulkOrderGuid, bulkOrderId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (mobileConflictMessage != "") {
            this.mobileConflict        = true;
            this.mobileConflictMessage = mobileConflictMessage;
          }
          this.bulkOrder=data;
          this.initialEmail=this.bulkOrder.email;
          this.initialMobile=this.canonicalMobile(data.mobile);
          this.populateFormFields();
          //this.validateProduct();

          this.openModal();

          //RBW_20260814 - Deferred to the next tick so the dial-code dropdown ViewChild has rendered before we touch it
          setTimeout(() => {
            if (this.initialUserExists && this.useInternationalDialCode) {
              this.dialCodeDropdown?.lockDownForm();
              return;
            }

            const dialCodeMissing = this.useInternationalDialCode &&
                                    !this.isIotDeviceSelected &&
                                    (this.bulkOrder?.mobile ?? "")        !== "" &&
                                    (this.bulkOrder?.mobileIntCode ?? "") === "";

            if (!this.bulkOrderForm.valid || dialCodeMissing) {
              this.formSubmitted = true;

              if (this.dialCodeDropdown != undefined)
                this.dialCodeDropdown.formSubmitted = true;
            }
          }, 0);
         },
        error: error => {
          this.bulkOrderFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
        this.bulkOrderModalFormRef = this.modalService.open(this.bulkOrderModalFormContent, { backdrop: this.modalBackGround, 
                                                            centered: true,
                                                            keyboard: false,
                                                            size    : msSize.ExtraLarge, //'mysize'
                                                            }); //windowClass: 'mysize' 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private populateFormFields() {
    try {
      if (this.bulkOrder != undefined) {
        this.bulkOrderForm.controls["dataWeightCode"].setValue(this.bulkOrder.dataWeightCode ?? "");
        this.bulkOrderForm.controls["deviceOS"].setValue(this.bulkOrder.deviceOS ?? "");
        this.bulkOrderForm.controls["eid"].setValue(this.bulkOrder.eid);
        this.bulkOrderForm.controls["email"].setValue(this.bulkOrder.email);
        this.bulkOrderForm.controls["firstname"].setValue(this.bulkOrder.firstname);
        this.bulkOrderForm.controls["iccid"].setValue(this.bulkOrder.iccid ?? "");
        this.bulkOrderForm.controls["inheritCompanyLimit"].setValue(this.bulkOrder.inheritCompanyLimit ?? true);
        this.bulkOrderForm.controls["inviewCostCentreIdLv1"].setValue(this.bulkOrder.costCentre);
        this.bulkOrderForm.controls["inviewCostCentreIdLv2"].setValue(this.bulkOrder.costCentre2);
        this.bulkOrderForm.controls["isIOTDevice"].setValue(this.bulkOrder.isIOTDevice ?? false);
        this.bulkOrderForm.controls["lastname"].setValue(this.bulkOrder.lastname);
        this.bulkOrderForm.controls["limitAmount"].setValue(this.bulkOrder.limitAmount ?? "");
        this.bulkOrderForm.controls["limitType"].setValue(this.bulkOrder.limitType ?? "");
        this.bulkOrderForm.controls["mobilenumber"].setValue(this.bulkOrder.mobile);
        this.bulkOrderForm.controls["mobilenumberE164"].setValue(this.bulkOrder.mobileE164);
        this.bulkOrderForm.controls["mobilenumberIntCode"].setValue(this.bulkOrder.mobileIntCode);
        this.bulkOrderForm.controls["product"].setValue(this.bulkOrder.product);
        this.bulkOrderForm.controls["productID"].setValue(this.bulkOrder.productID);
        this.bulkOrderForm.controls["provisionType"].setValue(this.bulkOrder.provisionType ?? DeviceActivationType.PushViaEID);
        this.bulkOrderForm.controls["simRef"].setValue(this.bulkOrder.simRef);
        this.bulkOrderForm.controls["simType"].setValue(this.bulkOrder.simType ?? eDeviceType.esim);
        this.bulkOrderForm.controls["tag"].setValue(this.bulkOrder.tag);
        this.bulkOrderForm.controls["tag2"].setValue(this.bulkOrder.tag2);

        this.applyProvisioningValidators();

        // this.bulkOrderForm.controls["active"].setValue(this.bulkOrder.product);
        // this.bulkOrderForm.controls["bulkOrderNo"].setValue(this.bulkOrder.bulkOrderNo); 
        // this.bulkOrderForm.controls["companyId"].setValue(this.bulkOrder.companyID);
        // this.bulkOrderForm.controls["deviceID"].setValue(this.bulkOrder.deviceID);
        // this.bulkOrderForm.controls["enteredBy"].setValue(this.bulkOrder.enteredBy);
        // this.bulkOrderForm.controls["enteredDate"].setValue(this.bulkOrder.enteredDate);
        // this.bulkOrderForm.controls["id"].setValue(this.bulkOrder.id);
        // this.bulkOrderForm.controls["inviewCompanyID"].setValue(this.bulkOrder.inviewCompanyID);
        // this.bulkOrderForm.controls["provisionedDate"].setValue(this.bulkOrder.provisionedDate);
        // this.bulkOrderForm.controls["status"].setValue(this.bulkOrder.status);
        // this.bulkOrderForm.controls["statusID"].setValue(this.bulkOrder.statusID);
        // this.bulkOrderForm.controls["supplierID"].setValue(this.bulkOrder.supplierID);
        // this.bulkOrderForm.controls["supplierOrderNo"].setValue(this.bulkOrder.supplierOrderNo);
        // this.bulkOrderForm.controls["updatedByUserId"].setValue(this.bulkOrder.updatedByUserId);
        // this.bulkOrderForm.controls["userID"].setValue(this.bulkOrder.userID);
      }        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private startProcess(): void {
    try {
      // this.resetMainVariables();
      this.refreshInviewCompanyData();
      this.refreshProductData();
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region provisioningBulkForm

  get formData() {
    return this.bulkOrderForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
      this.enableUserFields(!this.initialUserExists);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.bulkOrderForm);
      this.bulkOrderForm=this.formBuilder.group({ });
      this.addFormFields(this.bulkOrderForm);
      this.applyProvisioningValidators();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.bulkOrderForm) {
        //RBW_20260604 - EID / ICCID / DeviceOS validators are applied dynamically in applyProvisioningValidators
        this.addFormControl(formGroup, "companyId",             "", []);
        this.addFormControl(formGroup, "dataWeightCode",        "", []);
        this.addFormControl(formGroup, "deviceOS",              "", []);
        this.addFormControl(formGroup, "eid",                   "", []);
        this.addFormControl(formGroup, "email",                 "", [Validators.required, this.validatorService.emailValidator.bind(this.validatorService)]);
        this.addFormControl(formGroup, "firstname",             "", [Validators.required]);
        this.addFormControl(formGroup, "iccid",                 "", []);
        this.addFormControl(formGroup, "inheritCompanyLimit",   "", []);
        this.addFormControl(formGroup, "inviewCostCentreIdLv1", "", []);
        this.addFormControl(formGroup, "inviewCostCentreIdLv2", "", []);
        this.addFormControl(formGroup, "isIOTDevice",           "", []);
        this.addFormControl(formGroup, "lastname",              "", [Validators.required]);
        this.addFormControl(formGroup, "limitAmount",           "", []);
        this.addFormControl(formGroup, "limitType",             "", []);
        this.addFormControl(formGroup, "mobilenumber",          "", [Validators.required]);
        this.addFormControl(formGroup, "mobilenumberE164",      "", []);
        this.addFormControl(formGroup, "mobilenumberIntCode",   "", []);
        this.addFormControl(formGroup, "product",               "", [Validators.required, this.validatorService.valueInListValidator(() => (this.productIdData ?? []).map(p => p.description), "invalidProductSelection")]);
        this.addFormControl(formGroup, "productID",             "", []);
        this.addFormControl(formGroup, "provisionType",         "", [this.validatorService.selectionRequiredValidator.bind(this.validatorService)]);
        this.addFormControl(formGroup, "simRef",                "", []);
        this.addFormControl(formGroup, "simType",               "", [this.validatorService.selectionRequiredValidator.bind(this.validatorService)]);
        this.addFormControl(formGroup, "tag",                   "", []);
        this.addFormControl(formGroup, "tag2",                  "", []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public applyProvisioningValidators(): void {
    try {
      const provisionType = Number(this.bulkOrderForm.get("provisionType")?.value ?? DeviceActivationType.PushViaEID);
      const simType       = Number(this.bulkOrderForm.get("simType")?.value       ?? eDeviceType.esim);

      const isIotDevice       = this.isIotDeviceSelected;
      const physicalSim       = simType === eDeviceType.sim;
      const sendViaSmsEmail   = provisionType === DeviceActivationType.SendViaSMS || provisionType === DeviceActivationType.SendViaEmail;
      const provisioningByEid = provisionType === DeviceActivationType.PushViaEID;

      this.setControlValidators("provisionType", physicalSim
                                                 ? [this.validatorService.selectionRequiredValidator.bind(this.validatorService), this.validatorService.mustEqualValidator(DeviceActivationType.PushViaICCID, "iccidOnly")]
                                                 : isIotDevice
                                                 ? [this.validatorService.selectionRequiredValidator.bind(this.validatorService), this.validatorService.mustBeOneOfValidator([DeviceActivationType.PushViaEID, DeviceActivationType.SendViaManual], "iotDeploy")]
                                                 : [this.validatorService.selectionRequiredValidator.bind(this.validatorService)]);
      const eidValidators = provisioningByEid
                            ? [Validators.minLength(this.eidLength), Validators.maxLength(this.eidLength), Validators.pattern(`^[0-9]{${this.eidLength},${this.eidLength}}$`)]
                            : [];
      if (provisioningByEid && !physicalSim)
        eidValidators.unshift(Validators.required);
      this.setControlValidators("eid", eidValidators);
      this.setControlValidators("iccid",    physicalSim     ? [Validators.required]              : [this.validatorService.mustBeEmptyValidator.bind(this.validatorService)]);
      this.setControlValidators("deviceOS", sendViaSmsEmail ? [this.validatorService.selectionRequiredValidator.bind(this.validatorService)] : []);
      this.setControlValidators("email", isIotDevice
                                         ? []
                                         : [Validators.required, this.validatorService.emailValidator.bind(this.validatorService)]);
      this.setControlValidators("mobilenumber", isIotDevice
                                                ? []
                                                : [Validators.required]);

      const inheritCompanyLimit = this.bulkOrderForm.get("inheritCompanyLimit")?.value === true;
      const limitType           = Number(this.bulkOrderForm.get("limitType")?.value || 0);
      const needsAmount         = !inheritCompanyLimit && (limitType === LimitType.Spend || limitType === LimitType.Data);
      const needsDataWeight     = !inheritCompanyLimit && limitType === LimitType.Data;

      this.setControlValidators("limitType",      inheritCompanyLimit ? [] : [this.validatorService.selectionRequiredValidator.bind(this.validatorService)]);
      this.setControlValidators("limitAmount",    needsAmount         ? [Validators.required, Validators.min(0.0001)] : []);
      this.setControlValidators("dataWeightCode", needsDataWeight     ? [Validators.required] : []);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get isIotDeviceSelected(): boolean {
    return this.bulkOrderForm?.get("isIOTDevice")?.value === true;
  }

  private canonicalMobile = (value: string | null | undefined): string => {
    let digits = this.phoneNumberService.toDigits(value ?? "");

    if (digits.startsWith("44"))
      digits = digits.substring(2);

    digits = this.phoneNumberService.stripLeadingZeros(digits);

    return digits === "" ? "" : "0" + digits;
  };

  public iotDeviceChange(): void {
    try {
      if (this.isIotDeviceSelected)
        this.clearPersonContactFields();

      this.applyProvisioningValidators();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private clearPersonContactFields(): void {
    try {
      const fields = ["email", "mobilenumber", "mobilenumberE164", "mobilenumberIntCode"];

      fields.forEach(field => {
        const control = this.bulkOrderForm.get(field);

        if (control != null && control.value != null && control.value != "")
          control.setValue("", { emitEvent: false });
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setControlValidators(controlName: string, validators: ValidatorFn[]): void {
    try {
      const control = this.bulkOrderForm.get(controlName);

      if (control) {
        control.setValidators(validators);
        control.updateValueAndValidity({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public provisioningFieldChange(): void {
    try {
      this.applyProvisioningValidators();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  // public saveFormData() {
  //   try {
  //     this.formSubmitted=true;
      
  //     // if (this.provisioningBulkForm.valid) {
  //     //   let esimProvisioningDTO: EsimProvisioningDTO={
  //     //     eid             : this.provisioningBulkForm.controls["eid"].value,
  //     //     iccid           : this.provisioningBulkForm.controls["iccid"].value,
  //     //     inviewCompanyId : this.provisioningBulkForm.controls["inviewCompanyId"].value,
  //     //     inviewUserId    : this.provisioningBulkForm.controls["inviewUserId"].value,
  //     //     orderGuid       : this.provisioningBulkForm.controls["orderGuid"].value,
  //     //     productId       : this.provisioningBulkForm.controls["productID"].value
  //     //   }

  //     //   this.doProvisioning(esimProvisioningDTO);
  //     // }
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="inviewCompanyId") {
        return this.inviewCompanyIdData;

      } else if (fieldName=="product") {
        return this.productIdData;

      } else if (fieldName=="productID") {
        return this.productIdData;

      } else if (fieldName=="inviewCostCentreIdLv1") {
        return this.inviewCostCentreIdLv1Data;

      } else if (fieldName=="inviewCostCentreIdLv2") {
        return this.inviewCostCentreIdLv2Data;

      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  public getDropdownDataObjectArray_InviewUser() {
    try {
      return this.inviewUserIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="inviewCompanyId") {
              this.inviewCompanyIdData=(data as IdAndDescriptionDTO[]);

              if (!this.initialInviewCompanyIdSet && this.initialInviewCompanyId != undefined && this.initialInviewCompanyId>0) {
                this.bulkOrderForm.controls["inviewCompanyId"].setValue(this.initialInviewCompanyId);
                
                this.initialInviewCompanyIdSet=true;
              }

            } else if (fieldName=="productID") {
              this.productIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="inviewUserId") {
              this.inviewUserIdData=(data as InviewUserDTO[]);

            } else if (fieldName=="inviewCostCentreIdLv1") {
              //let fireOnChange=this.userForm.get('inviewCostCentreIdLv1')?.value != undefined && <number>this.userForm.get('inviewCostCentreIdLv1')?.value>0;

              this.inviewCostCentreIdLv1Data=(data as IdAndDescriptionDTO[]);

              // if (fireOnChange)
              //   this.costCentreLv1SelectDropDownChange(undefined);

            } else if (fieldName=="inviewCostCentreIdLv2") {
              let refreshCostCentreLv1Data=this.inviewCostCentreIdLv2Data==undefined || this.inviewCostCentreIdLv2Data.length==0;

              this.inviewCostCentreIdLv2Data=(data as IdAndDescriptionDTO[]);

              if (refreshCostCentreLv1Data)
                this.costCentreLv2SelectDropDownChange(undefined);
              
            }
           },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Inview Company
  
  public refreshInviewCompanyData() {
    try {
      //this.getDropdownData(this.inviewCompaniesService.getIdAndDescription(this.currUser.inviewUserId), "inviewCompanyId");
      this.refreshCostCentreLv2Data();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Inview User
  
  public refreshInviewUserData() {
    try {
      // this.inviewUserIdData=[];

      // if (this.selectedInviewCompany?.id != undefined && <number>this.selectedInviewCompany?.id>0) {
      //   this.getDropdownData(this.inviewUsersService.getByCompanyId(<number>this.selectedInviewCompany?.id ?? -1), "inviewUserId");
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  // public inviewUserDataHasBeenSaved(inviewUserId: number | undefined) {
  //   try {
  //     // if (inviewUserId != undefined && <number>inviewUserId>0) {
  //     //   this.registerInviewUser    =false;
  //     //   this.provisionButtonEnabled=true;

  //     //   this.provisioningBulkForm.controls["inviewUserId"].setValue(inviewUserId);

  //     //   this.refreshInviewUserData();
  //     // }
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }

  //#endregion

  //#region SureSIM Product

  public refreshProductData() {
    try {
      this.getDropdownData(this.productsService.getAvailableIdAndDescription(), "productID");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Provisioning

  //#endregion

  //#region Process Complete

  public completedModalHasBeenClosed() {
    try {
      if (this.embeddedFormMode) {
        this.startProcess();
      } 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public bulkOrderFormCancel() {
    try {
      this.bulkOrderFormCancelled.emit();
      this.bulkOrderModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public bulkOrderCompletedModalHasBeenClosed() {
    try {
      this.bulkOrderModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get formOfBulkOrderAdd() {
    return this.bulkOrderForm.controls;
  }

  // public validateProduct() {
  //     let id = this.productIdData.findIndex(item => item.description === this.bulkOrderForm.get('product')?.value)
  //     if (id == -1) {
  //        this.addCustomError('product', 'invalidProductSelection', 'Invalid product');
  //     }
  //     else {
  //       this.selectedProductid = Number(this.productIdData[id].id);
  //     }
  // }

  public bulkOrderFormSubmitAttempt() {
    try {
      this.formSubmitted=true;

      const isIotDevice = this.isIotDeviceSelected;
      const dialCodeHasNumber = (this.dialCodeDropdown?.dialCodeForm?.get("mobilenumber")?.value ?? "") != "";

      if (this.useInternationalDialCode && this.dialCodeDropdown != undefined && (!isIotDevice || dialCodeHasNumber)) {
        this.dialCodeDropdown.submit();

        const mobileNumber = this.dialCodeDropdown.outMobileNumber;
        const hasMobile    = mobileNumber != undefined && mobileNumber != "";

        if (this.dialCodeDropdown?.validData) {
          this.bulkOrderForm.controls["mobilenumber"       ].setValue(hasMobile ? "0" + mobileNumber                        : "");
          this.bulkOrderForm.controls["mobilenumberE164"   ].setValue(hasMobile ? this.dialCodeDropdown.outFullMobileNumber : "");
          this.bulkOrderForm.controls["mobilenumberIntCode"].setValue(hasMobile ? this.dialCodeDropdown.outIntDialCode      : "");
        }
      }

      //this.validateProduct();

      if (this.bulkOrderForm.valid && (isIotDevice || !this.useInternationalDialCode || this.dialCodeDropdown?.validData)) {
          this.bulkOrderFormSubmitCheckValues();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public bulkOrderFormSubmitCheckValues() {
    try {
      this.mobileNumberOK();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public mobileNumberOK() {
    try {
      const inviewUserId  = -1;
      const mobileToCheck = this.canonicalMobile(this.bulkOrderForm.get('mobilenumber')?.value);
      const formEmail     = this.bulkOrderForm.get('email')?.value ?? "";

      if (mobileToCheck == "") {
        this.mobileConflict = false;
        this.bulkOrderFormSubmit();
        return;
      }

      if (this.mobileConflict && mobileToCheck == this.initialMobile)
        return;

      forkJoin({
        eUser : this.usersService.mobileExistsOnDifferentUser(inviewUserId, mobileToCheck),
        inview: this.inviewUsersClisService.cliExistsOnDifferentUser(inviewUserId, mobileToCheck)
      })
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: ({ eUser, inview }) => {
          const eUserConflict  = (eUser.existsOnDifferentUser  ?? false) && eUser.email  != formEmail;
          const inviewConflict = (inview.existsOnDifferentUser ?? false) && inview.email != formEmail;

          if (eUserConflict) {
            this.mobileConflict        = true;
            this.mobileConflictMessage = "Mobile already assigned to another user";
          }
          else if (inviewConflict) {
            this.mobileConflict        = true;
            this.mobileConflictMessage = "Mobile found against different Inview Email";
          }
          else {
            this.mobileConflict        = false;
            this.bulkOrderFormSubmit();
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public bulkOrderFormSubmit() {
    try {
      this.prepareToSaveBulkOrder();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private prepareToSaveBulkOrder() {
    try {
      if (this.bulkOrder != undefined)
      {
        this.bulkOrder.costCentre          = this.bulkOrderForm.controls["inviewCostCentreIdLv1"].value;
        this.bulkOrder.costCentre2         = this.bulkOrderForm.controls["inviewCostCentreIdLv2"].value,
        this.bulkOrder.dataWeightCode      = this.bulkOrder.inheritCompanyLimit ? undefined : (this.bulkOrderForm.controls["dataWeightCode"].value || undefined);
        this.bulkOrder.deviceOS            = this.bulkOrderForm.controls["deviceOS"].value === "" ? undefined : Number(this.bulkOrderForm.controls["deviceOS"].value);
        this.bulkOrder.eid                 = this.bulkOrderForm.controls["eid"].value,
        this.bulkOrder.email               = this.bulkOrderForm.controls["email"].value,
        this.bulkOrder.firstname           = this.bulkOrderForm.controls["firstname"].value,
        this.bulkOrder.iccid               = this.bulkOrderForm.controls["iccid"].value;
        this.bulkOrder.inheritCompanyLimit = this.bulkOrderForm.controls["inheritCompanyLimit"].value === true;
        this.bulkOrder.inviewCostCentreID  = this.selectedInviewCostCentreLv1id;
        this.bulkOrder.inviewCostCentreID2 = this.selectedInviewCostCentreLv2id;
        this.bulkOrder.isIOTDevice         = this.bulkOrderForm.controls["isIOTDevice"].value === true;
        this.bulkOrder.lastname            = this.bulkOrderForm.controls["lastname"].value,
        this.bulkOrder.limitAmount         = this.bulkOrder.inheritCompanyLimit || this.bulkOrderForm.controls["limitAmount"].value === "" ? undefined : Number(this.bulkOrderForm.controls["limitAmount"].value);
        this.bulkOrder.limitType           = this.bulkOrder.inheritCompanyLimit || this.bulkOrderForm.controls["limitType"].value === "" ? undefined : Number(this.bulkOrderForm.controls["limitType"].value);
        this.bulkOrder.mobile              = this.bulkOrderForm.controls["mobilenumber"].value,
        this.bulkOrder.mobileE164          = this.bulkOrderForm.controls["mobilenumberE164"].value,
        this.bulkOrder.mobileIntCode       = this.bulkOrderForm.controls["mobilenumberIntCode"].value,
        this.bulkOrder.product             = this.bulkOrderForm.controls["product"].value,
        this.bulkOrder.productID           = this.selectedProductid ?? this.bulkOrderForm.controls["productID"].value;
        this.bulkOrder.provisionType       = Number(this.bulkOrderForm.controls["provisionType"].value);
        this.bulkOrder.simRef              = this.bulkOrderForm.controls["simRef"].value,
        this.bulkOrder.simType             = Number(this.bulkOrderForm.controls["simType"].value);
        this.bulkOrder.tag                 = this.bulkOrderForm.controls["tag"].value,
        this.bulkOrder.tag2                = this.bulkOrderForm.controls["tag2"].value,

        // active             : this.bulkOrderForm.controls["active"].value,
        // bulkOrderNo        : this.bulkOrderForm.controls["bulkOrderNo"].value, 
        // companyID          : this.bulkOrderForm.controls["companyId"].value,
        // deviceID           : this.bulkOrderForm.controls["deviceID"].value,
        // enteredBy          : this.bulkOrderForm.controls["enteredBy"].value,
        // enteredDate        : this.bulkOrderForm.controls["enteredDate"].value,
        // id                 : this.bulkOrderForm.controls["id"].value,
        // inviewCompanyID    : this.bulkOrderForm.controls["inviewCompanyID"].value,
        // productID          : this.bulkOrderForm.controls["productID"].value,
        // provisionedDate    : this.bulkOrderForm.controls["provisionedDate"].value,
        // status             : this.bulkOrderForm.controls["status"].value,
        // statusID           : this.bulkOrderForm.controls["statusID"].value,
        // supplierID         : this.bulkOrderForm.controls["supplierID"].value,
        // supplierOrderNo    : this.bulkOrderForm.controls["supplierOrderNo"].value,
        // updatedByUserId    : this.bulkOrderForm.controls["updatedByUserId"].value,
        // userID             : this.bulkOrderForm.controls["userID"].value
      //};

        this.saveBulkOrder(this.bulkOrder)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.alertColourProgress=AlertClassColour.Green;
            this.bulkOrderDataHasBeenSaved.emit(this.sureSimUserId);
            this.saveOrderProcessComplete();
          },
          error: error => {
            this.alertColourProgress=AlertClassColour.Red;
            this.progressInformation=`Process cannot continue - ${error.message}`;
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveOrderProcessComplete() {
    try {
      this.completedModalForm.openForm(this.bulkOrderSavedMessage, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveBulkOrder(bulkOrder: BulkOrderDTO): Observable<BulkOrderDTO> {
    return this.ordersService.saveBulk(bulkOrder);
  }

  public refreshCostCentreLv2Data() {
    try {
      //this.inviewCostCentreIdLv2Data=[];

      if (this.inviewCompanyId != undefined && <number>this.inviewCompanyId>0) {
        this.getDropdownData(this.inviewCostCentresService.getIdAndDescription_Lv2(<number>this.inviewCompanyId ?? -1), "inviewCostCentreIdLv2");
      }

      this.refreshCostCentreLv1Data();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public costCentreLv2SelectDropDownChange(ev: any) {
    try {
      // this.selectedInviewCostCentreLv2=this.inviewCostCentreIdLv2Data.find(x => x.id==this.bulkOrderForm.get('inviewCostCentreIdLv2')?.value);
      // this.costCentreLv1ButtonEnabled =this.selectedInviewCostCentreLv2?.id!=undefined && <number>this.selectedInviewCostCentreLv2?.id>0;

      // if (this.selectedInviewCostCentreLv2?.description==undefined || this.selectedInviewCostCentreLv2?.description.trim()=="") {
      //   this.costCentreMissingInInview=true;

      //   this.bulkOrderForm.controls["inviewCostCentreIdLv1"].enable();
      //   this.bulkOrderForm.controls["inviewCostCentreIdLv2"].enable();
      // }

      this.refreshCostCentreLv1Data();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public refreshCostCentreLv1Data() {
    try {
      //this.inviewCostCentreIdLv1Data=[];

      if (this.inviewCompanyId!=undefined &&
        <number>this.inviewCompanyId>0 &&
        this.selectedInviewCostCentreLv2id!=undefined &&
        <number>this.selectedInviewCostCentreLv2id>0
       ) {
        this.getDropdownData(this.inviewCostCentresService.getIdAndDescription_Lv1(<number>this.inviewCompanyId ?? -1, <number>this.selectedInviewCostCentreLv2id ?? -1), "inviewCostCentreIdLv1");
       }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addCustomError(controlName: string, errorKey: string, errorValue: any) {
    const control = this.bulkOrderForm.get(controlName);
    if (control) {
      control.setErrors({ ...control.errors, [errorKey]: errorValue });
    }
  }

  public costCentreLv1SelectDropDownChange(ev: any) {
    try {
      //this.selectedInviewCostCentreLv1=this.inviewCostCentreIdLv1Data.find(x => x.id==this.bulkOrderForm.get('inviewCostCentreIdLv1')?.value);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public emailkeyup(ev: any) {
    try {
      this.enableUserFields(this.initialEmail != this.bulkOrderForm.controls["email"].value);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public enableUserFields(enabled:boolean) {
    try {
      if (enabled) {
        this.bulkOrderForm.controls["firstname"].enable();
        this.bulkOrderForm.controls["inviewCostCentreIdLv1"].enable();
        this.bulkOrderForm.controls["inviewCostCentreIdLv2"].enable();
        this.bulkOrderForm.controls["lastname"].enable();
        this.bulkOrderForm.controls["mobilenumber"].enable();
        this.bulkOrderForm.controls["tag"].enable();
        this.bulkOrderForm.controls["tag2"].enable();
      } else {
        this.bulkOrderForm.controls["firstname"].disable();
        this.bulkOrderForm.controls["inviewCostCentreIdLv1"].disable();
        this.bulkOrderForm.controls["inviewCostCentreIdLv2"].disable();
        this.bulkOrderForm.controls["lastname"].disable();
        this.bulkOrderForm.controls["mobilenumber"].disable();
        this.bulkOrderForm.controls["tag"].disable();
        this.bulkOrderForm.controls["tag2"].disable();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public clearDataList(fieldname:string): void {
    if (fieldname == "inviewCostCentreIdLv2") {
      this.selectedInviewCostCentreLv2id = undefined;
    } else if (fieldname == "inviewCostCentreIdLv1") {
      this.selectedInviewCostCentreLv1id = undefined;
    } else if (fieldname == "product") {
      this.selectedProductid = undefined;
    }
    
    this.bulkOrderForm.controls[fieldname].setValue('');
  }

  public onSelect(event: Event, fieldname: string): void {
    if (fieldname == "inviewCostCentreIdLv2") {
      let id = this.inviewCostCentreIdLv2Data.findIndex(item => item.description === (event.target as HTMLInputElement).value)
      this.selectedInviewCostCentreLv2id = Number(this.inviewCostCentreIdLv2Data[id].id);
      this.costCentreLv2SelectDropDownChange(undefined);

    } else if (fieldname == "inviewCostCentreIdLv1") {
      let id = this.inviewCostCentreIdLv1Data.findIndex(item => item.description === (event.target as HTMLInputElement).value)
      this.selectedInviewCostCentreLv1id = Number(this.inviewCostCentreIdLv1Data[id].id);
    } else if (fieldname == "product") {
      //this.validateProduct();
      let id = this.productIdData.findIndex(item => item.description === this.bulkOrderForm.get('product')?.value)
      if (id > -1) {
        this.selectedProductid = Number(this.productIdData[id].id);
      }
      else {
        this.selectedProductid = undefined;
      }
    }
    const inputElement = event.target as HTMLInputElement;
    inputElement.blur(); // Removes focus from the input
  }

  /*
    //To fetch your initial data you will need to wrap your status$ observable in an action stream:
  // create a stream for your status request
  private readonly statusAction$ = new Status();

  status$ = this.statusAction$.pipe(
    startWith(''),
    concatMap(()=> {
      return this.statuservice.getStatus(); // this will be your http get request
    }),
  )

//Your getStatus method now will call this.statusAction$.next() on success, that will trigger the refetch of your status$ observable.
getStatus(): Observable<status[]> {
    return this.http.post<status[]>(this.myAppUrl + this.myApistatusUrl, this.authService.getLoggedUserFromSessionStorage())
      .pipe(
        retry(1),
        catchError(this.errorHandler),
        tap(() => this.statusAction$.next())
      );
  }
  
//With Interval
status$ = interval(30000)
    .pipe(
      startWith(''),
      switchMap(() => return this.statuservice.getStatus();)
    )
*/
  //#endregion
}
